import { Label, IToggleProps, Toggle, Text } from '@fluentui/react';
import { textProp } from 'global/Application';
import React from 'react';

interface IProps extends IToggleProps {

}

const ToggleControl: React.FunctionComponent<IProps> = (props) => {

    if (props.disabled) {

        let valueDescription = '---';

        if (props.checked === true)
            valueDescription = 'Yes';
        else if (props.checked === false)
            valueDescription = 'No';

        return <div style={textProp.root.style}>
            <Label styles={textProp.label}>{props.label}</Label>
            <Text styles={textProp.textStyles}>{valueDescription}</Text>
        </div>;
    }

    return <Toggle
        {...props}
    />;

}


export default ToggleControl